import { PeopleNotFound } from 'Pages/people/PeopleGroupDetail';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCompanyIntentData, selectCompanyIntentLoading, selectCompanyProfile } from 'Selector/CompaniesSelector';
import styled from 'styled-components';
import { CompanyIntent, CompanyProfile } from 'Types/CompaniesTypes';
import classNames from 'classnames';
import {
  boxShadow, secondaryFont, maxWidth,
  retina, maxMobile, maxTablet,
  greyColorSecondary, midMobile, wLight,
} from '../../../Utils/utilsStyle';
import SmallButton from './SmallButton';
import TagTip from './TagTip';
import ModalWidget from '../modal/ModalWidget';
import BulkTagSkeleton from '../skeleton/BulkTagSkeleton';
import SmartSourcedContentPopup from '../modal/SmartSourcedContentPopup';

const ArticleWrapper = styled.div`
  border-radius: 8px;
  padding: 26px 39px 24px 25px;
  box-shadow: ${boxShadow};
  background-color: #fff;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media all and (max-width: ${maxTablet}) {
    padding: 16px 16px 8px 16px;
  }

  &.listViewIntentData {
    padding: 24px 16px 24px 24px;

    @media all and (max-width: ${maxTablet}) {
      padding: 16px 16px 8px 16px;
    }
  }
  .heading {
    color: ${greyColorSecondary};
    font-family: ${secondaryFont};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.669px;
    margin-bottom: 13px;

    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 19px;
      line-height: 22px;
    }

    @media all and (max-width: ${maxMobile}) {
      font-size: 13px;
      line-height: 25px;
      margin-bottom: 6px;
    }
  }

  .buttons-part {
    margin-top: auto;

    @media all and (max-width: ${maxMobile}) {
      margin-top: 12px;
    }

    &.listViewButtonDiv {
      flex-direction: row-reverse;
      justify-content: flex-start;
      @media all and (max-width: ${midMobile}) {
        flex-direction: column;
      }
    }

    button{
      padding-left:18px;
      padding-right:18px;
       &:active{
      box-shadow: none;
      }
      &:focus {
        box-shadow: none;
      }  
       @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 11px;
        padding: 9px 15px;
      }
      + button{
        font-size:16px;
        font-weight: ${wLight};
        padding-right: 24px;
         @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 10px;
          line-height: 16px;
          padding: 9px 8px;
      }
      }
    }
  }
  .intent-sm-area {
    @media all and (max-width: ${midMobile}) {
      flex-direction: column;
    }
  }
`;
type Props = {
  listview: boolean;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

const ArticleTileGlobal = function ArticleTileGlobal(props: Props) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const companyIntentData: CompanyIntent | null = useSelector(selectCompanyIntentData);
  const companyIntent = companyIntentData?.companyIntent;
  const companyIntentDataLoading: boolean = useSelector(selectCompanyIntentLoading);
  const companyProfile: CompanyProfile | null = useSelector(selectCompanyProfile);

  const [showSmartContentPopup, setShowSmartContentPopup] = useState(false);
  const { listview } = props;
  const handleOnClickSmartContent = () => {
    setShowSmartContentPopup(true);
  };

  return (
    <ArticleWrapper className={classNames({ listViewIntentData: listview })}>
      {showSmartContentPopup ? (
        <SmartSourcedContentPopup
          width="801px"
          description="SmartSourced ™  Content, developed by xiQ, is intelligent content about the interests and topics that matter to each prospect. It is intelligently sourced, curated, and uses proprietary AI to extract insights, from the most reputable sources and combine with your own marketing collateral, about every individual prospect!"
          onClickCancel={() => setShowSmartContentPopup(false)}
          showSmartContentPopup={showSmartContentPopup}
        />
      ) : null}
      <h6 className="heading">{`What ${companyProfile?.companyName || 'Company'} is talking about right now:`}</h6>
      {' '}
      {/** Add Company NAME HERE */}
      <div>
        {companyIntentDataLoading ? <BulkTagSkeleton />
          : companyIntent && companyIntent?.length > 0 && companyIntent.map((intentDataItem) => (
            <TagTip
              title={intentDataItem}
              key={intentDataItem}
            />
          ))}
        {!companyIntentDataLoading
          && companyIntent?.length === 0
          && <PeopleNotFound>No results found</PeopleNotFound>}
      </div>
      {
        isModalVisible ? (
          <ModalWidget
            onClickNext={() => window.open('mailto:support@xiqinc.com')}
            onClickCancel={() => setIsModalVisible(false)}
            cancelText="Close"
            nextText="Contact Us"
            width="530px"
            title="Access Required"
            closePopup={false}
            nextLoading={false}
            description=""
            borderedButtons
          >
            <p className="main-message">You need to purchase xiQ’s AI powered ABM platform to generate content.</p>
          </ModalWidget>
        ) : null
      }
      <div className={classNames('buttons-part d-flex justify-content-between intent-sm-area', { listViewButtonDiv: listview })}>
        <SmallButton
          variant="filled"
          color="#001760"
          title="Generate SmartContent in Workbench"
          onButtonClick={() => {
            if (companyIntentData?.workbenchIntentPermission === 1) {
              if (companyIntentData.generate_intent_url.length) {
                window.open(companyIntentData.generate_intent_url);
              }
            } else {
              setIsModalVisible(true);
            }
          }}
        />
        <SmallButton
          variant="text"
          color="#001760"
          title="What is SmartContent?"
          onButtonClick={handleOnClickSmartContent}
          className="smallBtnText"
        />
      </div>
    </ArticleWrapper>
  );
};

export default ArticleTileGlobal;
